import {AbstractControl, FormControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export class PasswordValidator {
  // NEW Password
  static containsCorrectLength(maxLength: number) : ValidatorFn {
    return (fc: FormControl): ValidationErrors | null => {
      if (fc.value.length == 0 || fc.value.length < 8 || fc.value.length > maxLength) {
        return ({containsCorrectLength: true});
      }
      return null;
    }
  }


  static containsLowerCase(fc: FormControl) {
    if (/[a-z]/.test(fc.value)) {
      return null;
    } else {
      return ({containsLowerCase: true});
    }
  }

  static containsUpperCase(fc: FormControl) {
    if (/[A-Z]/.test(fc.value)) {
      return null;
    } else {
      return ({containsUpperCase: true});
    }
  }

  static containsNumber(fc: FormControl) {
    if (/[0-9]/.test(fc.value)) {
      return null;
    } else {
      return ({containsNumber: true});
    }
  }

  static notBasedOnUsername(username: string) : ValidatorFn {
    return (fc: FormControl) : {[notBasedOnUsername: string]: boolean} | null => {
      if (fc.value.length == 0 || fc.value.toLowerCase().indexOf(username.toLowerCase()) != -1) {
       return ({notBasedOnUsername: true});
      } else {
        return null;
      }
    }
  }

  static notContainsSpacedOrTabs(fc: FormControl) {
    if (fc.value.length == 0 || /\s/.test(fc.value)) {
      return ({notContainsSpacedOrTabs: true});
    } else {
      return null;
    }
  }

  static matchPassword(control: AbstractControl): {confirmPasswordFail: boolean} {
    if (control.get('confirmPassword').value) {
      if (control.get('newPassword').value != control.get('confirmPassword').value) {
        control.get('confirmPassword').setErrors({'confirmPasswordFail': true});
        return null;
      } else {
        control.get('confirmPassword').setErrors(null);
        return null;
      }
    }
  }
}
